import React, { FC } from 'react'
import { groupPostcodesByCity } from '../groupPostcodesByCity'
import { ListedLocations } from './ListedLocations'
import { TabbedLocations } from './TabbedLocations'

const LOCATIONS_NEEDED_FOR_TABS = 15

export const ProductLocations: FC<{
  locations: { city: string; postcode: string }[]
}> = ({ locations }) => {
  const postcodesByCity = groupPostcodesByCity(locations)

  return locations.length > LOCATIONS_NEEDED_FOR_TABS ? (
    <TabbedLocations postcodesByCity={postcodesByCity} />
  ) : (
    <ListedLocations postcodesByCity={postcodesByCity} />
  )
}
